export default {"src":"/_next/static/media/home_regular.c9721d43.svg","height":24,"width":24};